import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { WebserviceResponse, Kommentar, KommentarList, CombinedCommentDetail } from "../interfaces";
import { catchError, retry } from 'rxjs/operators';
import { AlertService, IAlertType } from "./alert.service";
import { restBaseUrl } from "../utils/rest-url";

@Injectable({
  providedIn: 'root'
})
export class CommentsStoreService {
  comment: Kommentar | undefined;

  private readonly endpoint = restBaseUrl('/comments');

  constructor(
      private http: HttpClient,
      private alertDispatcher: AlertService) { }

  private handleError(error: HttpErrorResponse){
    let errorMessage = 'Unknown error!';
    if (error.error instanceof ErrorEvent) {
      // Client-side errors
      errorMessage = `Client-side error: ${error.error.message}`;
    } else {
      // Server-side errors
      errorMessage = `Server-side error code: ${error.status} - message: ${error.message}`;
    }
    // window.alert(errorMessage);

    this.alertDispatcher.show({
      message: errorMessage,
      clrAlertType: IAlertType.DANGER
    }, 5000);

    // return throwError(errorMessage); deprecated
    return throwError(() => new Error(errorMessage));
  }

  public getComments(commentType: number, projectId: string, subId: number, done: boolean | null, staffId: number = 0): Observable<WebserviceResponse<CombinedCommentDetail[]>> {
    const options = new HttpParams({
      fromObject: {
        comment_type: commentType,
        project: projectId,
        person_id: 0,
        remember_from: 'null',
        remember_to: 'null',
        staff_id: staffId,
        sub_id: subId,
        done: done === null ? 'null' : done.toString(),
      }
    });
    return this.http.get<WebserviceResponse<CombinedCommentDetail[]>>(
        this.endpoint + '/get_comments',
        { params: options }).pipe(
            retry(3),
            catchError(this.handleError.bind(this))
    );
  }

  public getSingleComments(commentID: number): Observable<WebserviceResponse<KommentarList[]>> {
    const options = new HttpParams({
      fromObject: {
        material_id: commentID
      }
    });
    return this.http.get<WebserviceResponse<KommentarList[]>>(
        this.endpoint + '/get_single_comment',
        { params: options }).pipe(
            retry(3),
            catchError(this.handleError.bind(this))
    );
  }

  public updateComment(comment: KommentarList) {
    return this.http.put(
        `${this.endpoint}/update_comment`,
        comment,
        { responseType: 'json'}
    ).pipe(
        retry(3),
        catchError(this.handleError.bind(this))
    );
  }

  public updateCommentStatus(commentID: number, done: boolean) {
    return this.http.put(
        `${this.endpoint}/update_comment_done?id=${commentID}&done=${done}`,
        { responseType: 'json'}
    ).pipe(
        retry(3),
        catchError(this.handleError.bind(this))
    );
  }

  public addComment(comment: KommentarList) {
    return this.http.post(
        `${this.endpoint}/add_comment`,
        comment,
        { responseType: 'json'}
    ).pipe(
        retry(3),
        catchError(this.handleError.bind(this))
    );
  }

  public deleteComment(commentID: number) {
    return this.http.delete(
        `${this.endpoint}/delete_comment?id=${commentID}`,
        { responseType: 'text'}
    ).pipe(
        retry(3),
        catchError(this.handleError.bind(this))
    );
  }
}
